
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
import Select from 'react-select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TextField } from "@mui/material";
import * as moment from 'moment';
import * as service from '../../../services/service';

function AddEditQuotation() {
    const [state, setState] = useState({
        agencyname: '', quotationamount: '0', remarks: '', quotationfilename: '', quotationfilepath: '',
        eventperiod: '', earnestmoneydeposit: '0', onlinetenderfee: '0', performancesecurityvalue: '0', tenderamount: '0',
        marksheetfilename: '', marksheetfilepath: '',
    });
    const [data, setData] = useState([]);
    const [accountingYear, setAccountingYear] = useState('');
    const [receiptDate, setReceiptDate] = useState(new Date());
    const [tenderSubmissionDate, setTenderSubmissionDate] = useState(new Date());
    const [quotationFile, setQuotationFile] = useState('');
    const [markSheetFile, setMarkSheetFile] = useState('');
    const [status, setStatus] = useState('');
    const [quotationId, setQuotationId] = useState('');
    const [errors, setError] = useState({});
    const [loading, setLoading] = useState(false);
    const [editDisable, setEditDisable] = useState(false);
    const statusData = [{ value: "Pending", label: "Pending" }, { value: "Approved", label: "Approved" }, { value: "Rejected", label: "Rejected" }];
    const accountingYearData = [{ value: '2024-2025', label: '2024-2025' }, { value: '2025-2026', label: '2025-2026' },
    { value: '2026-2027', label: '2026-2027' }, { value: '2027-2028', label: '2027-2028' },
    { value: '2028-2029', label: '2028-2029' }, { value: '2029-2030', label: '2029-2030' }];
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    const eventName = JSON.parse(localStorage.getItem('eventname'))
    const categoryName = JSON.parse(localStorage.getItem('categoryname'))
    const eventExecution = JSON.parse(localStorage.getItem('eventexecution'))
    const navigate = useNavigate();
    const params = useParams();

    const getQuotationDetails = (

    ) => {
        fetch(
            service.GET_QUOTATION_BY_EVENT_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: JSON.stringify({
                    EventId: params.id,
                })
            })
            .then(res => res.json())
            .then(result => {
                setData(result);
                if (result.length === 0) {
                    setError('No Data Found');
                }
                else {                    
                    const item = result.find(obj => obj.status === 'Approved');                    
                    if (item) {                        
                        setEditDisable(true);
                    }
                }
            })
            .catch(err => {
                if (err) {
                    setError(err);
                };
            });
    };

    const getDetailsById = (id) => {
        setLoading(true);
        const errs = {};
        if (id > 0) {
            fetch(
                service.GET_QUOTATION_BY_ID,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: JSON.stringify({
                        QuotationId: id,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.message.messageType === 'Success') {
                        setState({
                            ...state, agencyname: result.agencyName, quotationamount: result.quotationAmount,
                            quotationfilename: result.quotationFileName, quotationfilepath: result.quotationFilePath,
                            remarks: result.remarks, eventperiod: result.eventPeriod, earnestmoneydeposit: result.earnestMoneyDeposit,
                            onlinetenderfee: result.onlineTenderFee, performancesecurityvalue: result.performanceSecurityValue,
                            tenderamount: result.tenderAmount, marksheetfilename: result.markSheetFileName, marksheetfilepath: result.markSheetFilePath,
                        });
                        const sta = ({ value: result.status, label: result.status });
                        setStatus(sta);
                        const ay = ({ value: result.accountingYear, label: result.accountingYear });
                        setAccountingYear(ay);
                        setReceiptDate(new Date(result.receiptDate));
                        setTenderSubmissionDate(new Date(result.tenderSubmissionDate));
                        setQuotationId(id);
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setError(errs);
                    }

                });
        }
        setLoading(false);
    };

    useEffect(() => {
        if (params.id > 0) {
            getQuotationDetails();
            const cc = ({ label: "Pending", value: "Pending" });
            setStatus(cc);
        }
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!state.agencyname) {
            isValid = false;
            errs[".agencyname"] = "Please enter agency name";
        }
        if (eventExecution === 'Quotation' && !state.quotationamount) {
            isValid = false;
            errs[".quotationamount"] = "Please enter quotation amount";
        }
        if (eventExecution === 'Quotation' && !receiptDate) {
            isValid = false;
            errs[".receiptDate"] = "Please enter receipt date";
        }
        if (eventExecution !== 'Quotation' && !state.tenderamount) {
            isValid = false;
            errs[".tenderamount"] = "Please enter tender amount";
        }
        if (eventExecution !== 'Quotation' && !tenderSubmissionDate) {
            isValid = false;
            errs[".tenderSubmissionDate"] = "Please enter tender submission date";
        }
        setError(errs);
        return isValid;
    }
    const changeHandler = (event) => {
        if (event.target.name === 'quotationamount' || event.target.name === 'tenderamount' || event.target.name === 'earnestmoneydeposit'
            || event.target.name === 'onlinetenderfee' || event.target.name === 'performancesecurityvalue') {
            if (Number.isNaN(parseFloat(event.target.value))) {
                // eslint-disable-next-line
                alert("Please enter numbers only");
                event.target.value = ""; // eslint-disable-line no-param-reassign
            }
        }
        setState({ ...state, [event.target.name]: event.target.value });
    };

    const statusChangeHandler = (ev) => {
        setStatus(ev);
    }
    const yearChangeHandler = (ev) => {
        setAccountingYear(ev);
    }
    const handleDownload = (fileName, filePath) => {
        setLoading(true);
        const formData = new FormData();
        formData.append("FileName", fileName);
        formData.append("FilePath", filePath);
        fetch(
            service.DOWNLOAD_FILE,
            {
                method: 'POST',
                headers: {                  
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: formData
            })
            .then((response) => response.blob())
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    fileName,
                );
                // Append to html link element page
                document.body.appendChild(link);
                // Start download
                link.click();
                // Clean up and remove the link
                link.parentNode.removeChild(link);
            });

        setLoading(false);
    };

    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validate()) {
            const formData = new FormData();
            formData.append("QuotationId", quotationId > 0 ? quotationId : 0);
            formData.append("EventId", params.id);
            formData.append("ReceiptDate", (new Date(receiptDate)).toUTCString());
            formData.append("AgencyName", state.agencyname);
            formData.append("QuotationAmount", state.quotationamount);
            formData.append("TenderSubmissionDate", (new Date(tenderSubmissionDate)).toUTCString());
            formData.append("AccountingYear", accountingYear.value);
            formData.append("EventPeriod", state.eventperiod);
            formData.append("EarnestMoneyDeposit", state.earnestmoneydeposit);
            formData.append("OnlineTenderFee", state.onlinetenderfee);
            formData.append("PerformanceSecurityValue", state.performancesecurityvalue);
            formData.append("TenderAmount", state.tenderamount);
            formData.append("Status", status.value);
            formData.append("Remarks", state.remarks);
            if (eventExecution === 'Quotation') {
                formData.append("QuotationFile", quotationFile);
            }
            else {
                formData.append("MarkSheetFile", markSheetFile);
            }
            formData.append("AddedBy", JSON.parse(window.sessionStorage.getItem('userData')).userId);
            formData.append("UpdatedBy", JSON.parse(window.sessionStorage.getItem('userData')).userId);
            fetch(
                service.ADD_UPDATE_QUOTATION,
                {
                    method: 'POST',
                    headers: {                  
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: formData
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        window.location.reload();
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setError(errs);
                    }
                });
        }
        setLoading(false);
    }

    const backHandler = () => {
        localStorage.setItem('eventname', null);
        localStorage.setItem('categoryname', null);
        localStorage.setItem('agencyname', null);        
        localStorage.setItem('quotationamount', null);
        localStorage.setItem('eventexecution', null);
        localStorage.setItem('expensehead', null);
        navigate('/events/event');
    }

    const handleDelete = (qId) => {
        if (window.confirm(`Do you want to delete this record?`)) {
            fetch(
                service.DELETE_QUOTATION,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: JSON.stringify({
                        QuotationId: qId,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        getQuotationDetails();
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                    }
                    else {
                        // eslint-disable-next-line
                        alert(result.message);
                    }
                });
        }
    }

    const handleEdit = (id) => {
        getDetailsById(id);
    }

    const handleWorkOrder = (qId, evId, agName, qAmt) => {
        localStorage.setItem('agencyname', JSON.stringify(agName));
        localStorage.setItem('quotationamount', JSON.stringify(qAmt));
        localStorage.setItem('eventexecution', JSON.stringify(eventExecution));
        navigate(`/addeditworkorder/${qId}/${evId}`);
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Quotation Details
                                </MDTypography>
                            </MDBox>
                            <Card style={{ alignItems: 'center' }}>
                                {/* <TableContainer component={Paper} style={{ width: '90%', alignSelf: 'center', }}> */}
                                <Table>
                                    <TableRow>
                                        <TableCell width="30%" style={{ fontWeight: 'bold' }}>
                                            Event Category : {categoryName}
                                        </TableCell>
                                        <TableCell width="30%" style={{ fontWeight: 'bold' }}>
                                            Event Name : {eventName}
                                        </TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>
                                            Event Execution : {eventExecution}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Agency Name" fullWidth value={state.agencyname || ''}
                                                name="agencyname"
                                                onChange={changeHandler}
                                                id="agencyname"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".agencyname"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <Select
                                                options={statusData}
                                                name="status"
                                                value={status}
                                                onChange={statusChangeHandler}
                                                isSearchable
                                                styles={selectStyles}
                                                placeholder="Select Status"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".status"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <MDInput label="Remarks" fullWidth value={state.remarks || ''}
                                                name="remarks"
                                                onChange={changeHandler}
                                                id="remarks"
                                                multiline
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".remarks"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan="3" align="center" style={{backgroundColor: 'ButtonFace'}}>
                                            <Table>
                                                <TableRow>
                                                    <TableCell colSpan="3" align="center" style={{ fontWeight: 'bold' }}>For Quotation</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell width="30%">
                                                        <MDInput label="Quotation Amount" fullWidth value={state.quotationamount || ''}
                                                            name="quotationamount"
                                                            onChange={changeHandler}
                                                            id="quotationamount"
                                                            disabled={eventExecution !== 'Quotation'}
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".quotationamount"]}</div>
                                                    </TableCell>
                                                    <TableCell width="30%">
                                                        <div> Receipt Date </div>
                                                        <DatePicker
                                                            id="receiptDate"
                                                            selected={receiptDate}
                                                            onChange={date => setReceiptDate(date)}
                                                            dateFormat="MM/dd/yyyy"
                                                            tabIndex={0}
                                                            disabled={eventExecution !== 'Quotation'}
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".receiptDate"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div>Upload Quotation File (File Size 5 MB)</div>
                                                        <TextField
                                                            id="quotationFile"
                                                            type="file"
                                                            onChange={ev => setQuotationFile(ev.target.files[0])}
                                                            style={{ width: 200 }}
                                                            disabled={eventExecution !== 'Quotation'}
                                                        />
                                                        {state.quotationfilename ?
                                                            <MDButton onClick={() => handleDownload(state.quotationfilename, state.quotationfilepath)}>{state.quotationfilename}</MDButton>
                                                            : null}
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".quotationFile"]}</div>
                                                    </TableCell>
                                                </TableRow>
                                            </Table>
                                        </TableCell>
                                    </TableRow>
                                    <br />
                                    <br />
                                    <TableRow>
                                        <TableCell colSpan="3" align="center" style={{backgroundColor: 'ButtonFace'}}>
                                            <Table>
                                                <TableRow>
                                                    <TableCell colSpan="3" align="center" style={{ fontWeight: 'bold' }}>For Open/Closed Tender</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell width="30%">
                                                        <div> Tender Submission Date </div>
                                                        <DatePicker
                                                            id="tenderSubmissionDate"
                                                            selected={tenderSubmissionDate}
                                                            onChange={date => setTenderSubmissionDate(date)}
                                                            dateFormat="MM/dd/yyyy"
                                                            tabIndex={0}
                                                            disabled={eventExecution === 'Quotation'}
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".tenderSubmissionDate"]}</div>
                                                    </TableCell>
                                                    <TableCell width="30%">
                                                        <Select
                                                            options={accountingYearData}
                                                            name="accountingYear"
                                                            value={accountingYear}
                                                            onChange={yearChangeHandler}
                                                            isSearchable
                                                            styles={selectStyles}
                                                            placeholder="Select Accounting Year"
                                                            isDisabled={eventExecution === 'Quotation'}
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".accountingYear"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <MDInput label="Event Period" fullWidth value={state.eventperiod || ''}
                                                            name="eventperiod"
                                                            onChange={changeHandler}
                                                            id="eventperiod"
                                                            disabled={eventExecution === 'Quotation'}
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".eventperiod"]}</div>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>
                                                        <MDInput label="Earnest Money Deposit" fullWidth value={state.earnestmoneydeposit || ''}
                                                            name="earnestmoneydeposit"
                                                            onChange={changeHandler}
                                                            id="earnestmoneydeposit"
                                                            disabled={eventExecution === 'Quotation'}
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".earnestmoneydeposit"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <MDInput label="Online Tender Fee" fullWidth value={state.onlinetenderfee || ''}
                                                            name="onlinetenderfee"
                                                            onChange={changeHandler}
                                                            id="onlinetenderfee"
                                                            disabled={eventExecution === 'Quotation'}
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".onlinetenderfee"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <MDInput label="Performance Security Value" fullWidth value={state.performancesecurityvalue || ''}
                                                            name="performancesecurityvalue"
                                                            onChange={changeHandler}
                                                            id="performancesecurityvalue"
                                                            disabled={eventExecution === 'Quotation'}
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".performancesecurityvalue"]}</div>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>
                                                        <MDInput label="Tender Amount" fullWidth value={state.tenderamount || ''}
                                                            name="tenderamount"
                                                            onChange={changeHandler}
                                                            id="tenderamount"
                                                            disabled={eventExecution === 'Quotation'}
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".tenderamount"]}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div>Upload Mark Sheet File (File Size 5 MB)</div>
                                                        <TextField
                                                            id="markSheetFile"
                                                            type="file"
                                                            onChange={ev => setMarkSheetFile(ev.target.files[0])}
                                                            style={{ width: 200 }}
                                                            disabled={eventExecution === 'Quotation'}
                                                        />
                                                        {state.marksheetfilename ?
                                                            <MDButton onClick={() => handleDownload(state.marksheetfilename, state.marksheetfilepath)}>{state.marksheetfilename}</MDButton>
                                                            : null}
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".markSheetFile"]}</div>
                                                    </TableCell>
                                                </TableRow>
                                            </Table>
                                        </TableCell>
                                    </TableRow>                                  
                                </Table>
                                {/* </TableContainer> */}
                                <MDBox mt={4} mb={1} textAlign="center">
                                    {loading ? <Oval
                                        heigth="20"
                                        width="20"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                        <div>
                                            <MDButton color="info" onClick={submitHandler}>
                                                SAVE
                                            </MDButton>  &nbsp;&nbsp;&nbsp;&nbsp;
                                            <MDButton color="info" onClick={backHandler}>
                                                BACK
                                            </MDButton>
                                        </div>
                                    }
                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                </MDBox>
                            </Card>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                        {eventExecution === 'Quotation' ?
                                            <Table aria-label="simple table">
                                                <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Agency Name</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Quotation Amount</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Receipt Date</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>File</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Remarks</TableCell>
                                                    <TableCell colSpan="3" align="center" style={{ fontWeight: 'bold' }}>Action</TableCell>
                                                </TableRow>
                                                <TableBody>
                                                    {data.map((row) => (
                                                        <TableRow
                                                            key={row.quotationId}
                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                        >
                                                            <TableCell width="15%" component="th" scope="row">{row.agencyName}</TableCell>
                                                            <TableCell width="15%" component="th" scope="row">{row.quotationAmount}</TableCell>
                                                            <TableCell width="10%" component="th" scope="row">{moment(row.receiptDate).format('DD/MM/YYYY')}</TableCell>
                                                            <TableCell width="20%" component="th" scope="row"><MDButton onClick={() => handleDownload(row.quotationFileName, row.quotationFilePath)}>{row.quotationFileName}</MDButton></TableCell>
                                                            <TableCell width="15%" component="th" scope="row">{row.status}</TableCell>
                                                            <TableCell width="15%" component="th" scope="row">{row.remarks}</TableCell>
                                                            <TableCell><MDButton onClick={() => handleEdit(row.quotationId)} disabled={editDisable}>Edit</MDButton></TableCell>
                                                            <TableCell><MDButton onClick={() => handleDelete(row.quotationId)} disabled={editDisable}>Delete</MDButton></TableCell>
                                                            <TableCell><MDButton onClick={() => handleWorkOrder(row.quotationId, params.id, row.agencyName, row.quotationAmount)} disabled={row.status !== "Approved"}>Work Order</MDButton></TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                            :
                                            <Table aria-label="simple table">
                                                <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Agency Name</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Tender Amount</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Tender Submission Date</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>File</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Remarks</TableCell>
                                                    <TableCell colSpan="3" align="center" style={{ fontWeight: 'bold' }}>Action</TableCell>
                                                </TableRow>
                                                <TableBody>
                                                    {data.map((row) => (
                                                        <TableRow
                                                            key={row.quotationId}
                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                        >
                                                            <TableCell width="15%" component="th" scope="row">{row.agencyName}</TableCell>
                                                            <TableCell width="15%" component="th" scope="row">{row.tenderAmount}</TableCell>
                                                            <TableCell width="10%" component="th" scope="row">{moment(row.tenderSubmissionDate).format('DD/MM/YYYY')}</TableCell>
                                                            <TableCell width="20%" component="th" scope="row"><MDButton onClick={() => handleDownload(row.markSheetFileName, row.markSheetFilePath)}>{row.markSheetFileName}</MDButton></TableCell>
                                                            <TableCell width="15%" component="th" scope="row">{row.status}</TableCell>
                                                            <TableCell width="15%" component="th" scope="row">{row.remarks}</TableCell>
                                                            <TableCell><MDButton onClick={() => handleEdit(row.quotationId)} disabled={editDisable}>Edit</MDButton></TableCell>
                                                            <TableCell><MDButton onClick={() => handleDelete(row.quotationId)} disabled={editDisable}>Delete</MDButton></TableCell>
                                                            <TableCell><MDButton onClick={() => handleWorkOrder(row.quotationId, params.id, row.agencyName, row.tenderAmount)} disabled={row.status !== "Approved"}>Work Order</MDButton></TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        }
                                    </TableContainer>
                                }
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default AddEditQuotation;